/**
 * @flow
 * @relayHash 5ddffcaf2ef03a888e7f345b504084de
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileInviteFriendContainer_app$ref = any;
type ProfileInviteFriendContainer_user$ref = any;
export type ProfileInviteFriendViewQueryVariables = {|
  userId: string
|};
export type ProfileInviteFriendViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: ProfileInviteFriendContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: ProfileInviteFriendContainer_user$ref
  |},
|};
export type ProfileInviteFriendViewQuery = {|
  variables: ProfileInviteFriendViewQueryVariables,
  response: ProfileInviteFriendViewQueryResponse,
|};
*/


/*
query ProfileInviteFriendViewQuery(
  $userId: String!
) {
  app {
    ...ProfileInviteFriendContainer_app
    id
  }
  user(userId: $userId) {
    ...ProfileInviteFriendContainer_user
    id
  }
}

fragment ProfileInviteFriendContainer_app on App {
  referralVcReward
}

fragment ProfileInviteFriendContainer_user on User {
  numUsersRecruited
  ...InviteFriendContainer_user
}

fragment InviteFriendContainer_user on User {
  username
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProfileInviteFriendViewQuery",
  "id": null,
  "text": "query ProfileInviteFriendViewQuery(\n  $userId: String!\n) {\n  app {\n    ...ProfileInviteFriendContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...ProfileInviteFriendContainer_user\n    id\n  }\n}\n\nfragment ProfileInviteFriendContainer_app on App {\n  referralVcReward\n}\n\nfragment ProfileInviteFriendContainer_user on User {\n  numUsersRecruited\n  ...InviteFriendContainer_user\n}\n\nfragment InviteFriendContainer_user on User {\n  username\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileInviteFriendViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileInviteFriendContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileInviteFriendContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileInviteFriendViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "referralVcReward",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numUsersRecruited",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd487adab777b4260ebde88a95f91e674';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileInviteFriendViewQuery.graphql.js